import { Spinner } from "flowbite-react";
import { useState, useEffect } from "react";

import { useIntegrations } from "../../../../contexts/IntegrationsContext";
import { SlackHeader } from "./SlackHeader";
import { SlackCredentialsForm } from "./SlackCredentialsForm";

const SlackConnectedInfo = () => (
  <div className="px-6 pb-4">
    <p className="text-sm text-gray-600">
      Slack is connected. Panora reads the channels its bot has been invited to.
      For each client channel you want Panora to watch, run{" "}
      <code>/invite @Panora</code> in that channel.
    </p>
    <p className="mt-2 text-sm text-gray-500">
      Next, attach each client&apos;s channel to its account on the customer
      details page.
    </p>
  </div>
);

export const SlackIntegration = () => {
  const { loading, isIntegrationConnected, getIntegrationById } =
    useIntegrations();

  const [credentials, setCredentials] = useState({
    token: "",
    teamDomains: "",
  });

  const isConnected = isIntegrationConnected("slack");
  const integration = getIntegrationById("slack");

  // Clear the pasted token from memory once connected.
  useEffect(() => {
    if (isConnected) {
      setCredentials({ token: "", teamDomains: "" });
    }
  }, [isConnected]);

  if (loading) {
    return (
      <div className="flex h-48 items-center justify-center">
        <Spinner size="lg" aria-label="Loading Slack integration" />
      </div>
    );
  }

  return (
    <div className="flex min-h-full flex-1 flex-col gap-4">
      <div className="animation-slide-up-lil-bounce mt-1 flex w-full flex-col gap-4 overflow-x-auto rounded-lg bg-white py-4 shadow">
        <SlackHeader
          isConnected={isConnected}
          integration={integration}
          credentials={credentials}
        />

        <hr className="border-gray-200" />

        {isConnected ? (
          <SlackConnectedInfo />
        ) : (
          <SlackCredentialsForm
            credentials={credentials}
            onCredentialsChange={setCredentials}
          />
        )}
      </div>
    </div>
  );
};
